import type { GetArenaMatchmakingTiersResponse } from "@cede/types";
import { API_ENDPOINT } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useQuery } from "@tanstack/react-query";

const ARENA_MATCHMAKING_TIERS_QUERY_KEY = ["cede-arena", "matchmaking-tiers"] as const;

const ONE_MINUTE_MS = 60 * 1000;

/**
 * Public per-tier matchmaking config. Hub reads it only to disclose how many
 * priority tickets each Arena buy-in awards. No auth required; short stale time
 * so a CMS edit surfaces without a hard reload.
 */
export const useArenaMatchmakingTiers = () => {
  const apiHelper = useApi();

  return useQuery<GetArenaMatchmakingTiersResponse>({
    queryKey: ARENA_MATCHMAKING_TIERS_QUERY_KEY,
    queryFn: () => apiHelper.getOrThrow(API_ENDPOINT.CEDE_ARENA_MATCHMAKING_TIERS),
    staleTime: ONE_MINUTE_MS,
    gcTime: 5 * 60 * 1000,
  });
};
